import { CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

import config from '@/config';

export const getCurrentUser = (): Nullable<CognitoUser> => {
  const cognitoUserPool = new CognitoUserPool({
    ClientId: config.cognito.APP_CLIENT_ID,
    UserPoolId: config.cognito.USER_POOL_ID,
  });

  const cognitoUser = cognitoUserPool.getCurrentUser();

  if (cognitoUser) {
    return cognitoUser;
  }

  // In config APP_CLIENT_ID and SSO_APP_CLIENT_ID are the same. So this one might be redundant. Leave it in case these values are different on other envs
  const ssoUserPool = new CognitoUserPool({
    ClientId: config.cognito.SSO_APP_CLIENT_ID,
    UserPoolId: config.cognito.USER_POOL_ID,
  });

  return ssoUserPool.getCurrentUser();
};
